import React, { Component } from "react";
import { browserHistory } from "react-router";

import Image from "./../../../../components/ZUILib/Image";
import commonUtil from "../../../../utils/commonUtil";
import { constEventStatus, eventType } from "../../../../utils/clientConstant";

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();
// const baseURL = commonUtil.getAppBaseURL();

class EventDescription extends Component {
  constructor(props) {
    super(props);
    this.imagePath = "";
  }
  redirectToAdminpage = () => {
    if (this.props.eventStatus !== constEventStatus.DELETEDBYFRAUD) {
      if (
        this.props.eventStatus === constEventStatus.SUSPENDEDFORTIME ||
        this.props.eventStatus === constEventStatus.DELETED
      ) {
        browserHistory.push(
          commonUtil.getRouteByParameter(
            applicationRoutes.eventStatusSuspendedForTime
          )
        );
      } else {
        browserHistory.push(
          commonUtil.getRouteByParameter(applicationRoutes.giftList, {
            eventID: this.props.eventId,
          })
        );
      }
    }
  };
  render() {
    const imgsrc = [
      {
        srcSet: this.imagePath,
      },
    ];

    const imageAttr = {
      src: "",
    };
    switch (this.props.eventType) {
      case eventType.Boda:
      case eventType.Aniversario:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_bodas.svg";
        break;
      case eventType.Baptism:
      case eventType.Bebe:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_bebes.svg";
        break;
      case eventType.XV_Anos:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_quince.svg";
        break;
      case eventType.Bar_Mitzvah:
      case eventType.Bat_Mitzvah:
      case eventType.First_Communion:
      case eventType.Confirmacion:
      case eventType.Open_House:
      case eventType.Despedida:
      case eventType.Others:
      case eventType.Mascotas:
      case eventType.Other_Religious_Ceremonies:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_ceremonias.svg";
        break;
      case eventType.Fiesta_Infantil:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_cumple.svg";
        break;
      case eventType.Cumpleanos:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_cumpleanos.svg";
        break;
      case eventType.Fiesta_Reunion:
        this.imagePath =
          commonUtil.getAssetURL() + "/images/guest/mesa_todotipo.svg";
        break;
      default:
        break;
    }
    imageAttr.src = this.imagePath;
    imageAttr.className = "changeWeddingOn";

    const notAccessible =
      this.props.eventStatus === constEventStatus.DELETEDBYFRAUD
        ? " hover-default"
        : "";

    return (
      <div
        className={
          channel === "web" && this.props.eventDetaillength > 2
            ? "col-xs-4"
            : "col-xs-6"
        }
        onClick={this.redirectToAdminpage}
      >
        <a
          className={
            this.props.eventDetaillength > 2 ? "imgMesa" + notAccessible : ""
          }
        >
          <div
            className={this.props.eventDetaillength > 2 ? "logoContent" : ""}
          >
            <Image imageAttr={imageAttr} _imgsrc={imgsrc} />
          </div>
          <p className={this.props.eventDetaillength > 2 ? "nameEvent" : ""}>
            {this.props.eventName}
          </p>
          {this.props.eventStatus &&
          this.props.eventStatus !== constEventStatus.ACTIVE ? (
            <span className="statusEvent">{this.props.eventStatus}</span>
          ) : null}
        </a>
      </div>
    );
  }
}
export default EventDescription;
